/* eslint-disable consistent-return */
import {
  useEffect, EffectCallback, DependencyList, useRef, useLayoutEffect,
} from 'react';

/**
 * These hook gets called only when the dependencies change but not during initial render.
 * https://medium.com/swlh/prevent-useeffects-callback-firing-during-initial-render-the-armchair-critic-f71bc0e03536
 *
 * @param {EffectCallback} effect The `useEffect` callback function.
 * @param {DependencyList} deps An array of dependencies.
 *
 */

// eslint-disable-next-line max-len
function createReactEffect( initialRender: React.MutableRefObject<boolean>, effect: EffectCallback ) {
  return () => {
    if ( initialRender.current ) {
      initialRender.current = false;
      return;
    }
    return effect();
  };
}
export const useNonInitialEffect = ( effect: EffectCallback, deps: DependencyList ) => {
  const initialRender = useRef( true );

  useEffect( createReactEffect( initialRender, effect ), deps );
};

export const useNonInitialLayoutEffect = ( effect: EffectCallback, deps: DependencyList ) => {
  const initialRender = useRef( true );

  useLayoutEffect( createReactEffect( initialRender, effect ), deps );
};
